
































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Tab,
  Tabs,
} from "vant";
import api from "../../../components/http/api";
import { SydPointsInfo, SydUpdatelog } from "./SydApi";

declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
})
export default class SydAwardingHome extends Vue {
  private loadNumUp = 5;
  private pageNum = 0;
  private loading: boolean = false;
  private finished: boolean = false;
  private infoList = [];

  private sydpoints: string = "";
  private sydtabactive: number = 0;

  protected created() {
    this.getSydPoints();
  }

  protected getSydPoints() {
    api.post("/weixinmp/xsyx/merchant/getSydBaseInfo", {}).then((res: any) => {
      this.sydpoints = res.data.sydPoints;
    });
  }

  protected loadList() {
    setTimeout(() => {
      const page = {
        ep: this.loadNumUp,
        sp: ++this.pageNum,
      };
      api
        .post("/weixinmp/xsyx/merchant/getSydUpdatelogList", page)
        .then((res: any) => {
          const ss = res.data;
          console.log(ss);
          if (ss.length != 0) {
            this.infoList = this.infoList.concat(ss);
          }
          if (ss.length == 0) {
            this.finished = true;
          }
          this.loading = false;
        });
    }, 1000);
  }

  protected toSydHome() {
    this.$router.push("/main/syd/sydHome");
  }

  protected toAwardingDetail(activityid: any) {
    this.$router.push("/main/syd/sydAwardingDetail/" + activityid);
  }
}
